import React, {Component, Fragment} from 'react';
import {Trans, withTranslation} from 'react-i18next';
import {Helmet} from "react-helmet";
import {GelContentContainer, withAuthentication, Notice} from "cw-styleguide-react";


class NotFoundView extends Component {

  /**
   * render
   * @returns {JSX.Element}
   */
    render() {
        return (
          <Fragment>
            <Helmet>
              <title>{this.props.t('view.landing.title')}</title>
            </Helmet>

            <GelContentContainer>
              <h1>{this.props.t('local:view.notFound.title')}</h1>
            </GelContentContainer>
            <GelContentContainer>
              <Notice type={'info'}>
                <Trans i18nKey="local:view.notFound.introduction"
                       />
              </Notice>
            </GelContentContainer>
          </Fragment>
        )
    }

}

export default withAuthentication(withTranslation('local')(NotFoundView));
